import React from 'react'

const PhotoGrid = () => {
  return (
    
    <div className="gallery-main">
      <div className="gallery-container">
        <div className="container">          <div className="row-main">
            <div className="column-main">
              <div className="big-main img50"></div>
            </div>
            <div className="column-main">
              <div className="row">
                <div className="big img42"></div>
                <div className="small img49"></div>
              </div>
              <div className="row">
                <div className="small img44"></div>
                <div className="big img45"></div>
              </div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="row">
                <div className="big img46"></div>
                <div className="small img47"></div>
              </div>
              <div className="row">
                <div className="small img41"></div>
                <div className="big img43"></div>
              </div>
            </div>
            <div className="column-main">
              <div className="big-main img48"></div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="big-main img1"></div>
            </div>
            <div className="column-main">
              <div className="row">
                <div className="big img2"></div>
                <div className="small img3"></div>
              </div>
              <div className="row">
                <div className="small img4"></div>
                <div className="big img5"></div>
              </div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="row">
                <div className="big img6"></div>
                <div className="small img7"></div>
              </div>
              <div className="row">
                <div className="small img8"></div>
                <div className="big img9"></div>
              </div>
            </div>
            <div className="column-main">
              <div className="big-main img10"></div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="big-main img11"></div>
            </div>
            <div className="column-main">
              <div className="row">
                <div className="big img12"></div>
                <div className="small img13"></div>
              </div>
              <div className="row">
                <div className="small img14"></div>
                <div className="big img15"></div>
              </div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="row">
                <div className="big img16"></div>
                <div className="small img17"></div>
              </div>
              <div className="row">
                <div className="small img18"></div>
                <div className="big img19"></div>
              </div>
            </div>
            <div className="column-main">
              <div className="big-main img20"></div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="big-main img21"></div>
            </div>
            <div className="column-main">
              <div className="row">
                <div className="big img22"></div>
                <div className="small img23"></div>
              </div>
              <div className="row">
                <div className="small img24"></div>
                <div className="big img25"></div>
              </div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="row">
                <div className="big img26"></div>
                <div className="small img27"></div>
              </div>
              <div className="row">
                <div className="small img28"></div>
                <div className="big img29"></div>
              </div>
            </div>
            <div className="column-main">
              <div className="big-main img30"></div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="big-main img31"></div>
            </div>
            <div className="column-main">
              <div className="row">
                <div className="big img32"></div>
                <div className="small img33"></div>
              </div>
              <div className="row">
                <div className="small img34"></div>
                <div className="big img35"></div>
              </div>
            </div>
          </div>
          <div className="row-main">
            <div className="column-main">
              <div className="row">
                <div className="big img36"></div>
                <div className="small img37"></div>
              </div>
              <div className="row">
                <div className="small img38"></div>
                <div className="big img39"></div>
              </div>
            </div>
            <div className="column-main">
              <div className="big-main img40"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default PhotoGrid